var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-content"},[_c('div',{staticStyle:{"flex":"1"}},[(_vm.view || _vm.report_id)?_c('hb-report',{key:_vm.report_key,attrs:{"report_id":_vm.report_id,"report_type":_vm.view,"show_title":"","actions_panel":_vm.actions_panel,"right_click":"","row_click":"","show_search":""}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }